export default "/kiban/_next/static/images/materialsArrivalDate-d970b11c75eceb67623b6d4387f90270.png";